import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import List from './List'
import Create from './Create'
import Edit from './Edit'
import Show from './Show'

const Hospital = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <List />
      </Route>
      <Route exact path={`${path}/create`}>
        <Create />
      </Route>
      <Route exact path={`${path}/:id`}>
        <Show />
      </Route>
      <Route exact path={`${path}/:id/edit`}>
        <Edit />
      </Route>
    </Switch>
  )
}

export default Hospital
